import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Button } from '../Button';
import { Field, getId } from '../Field/Field';
import { fieldMaxWidth as defaultFieldMaxWidth } from '../Field/Field.styled';
import { FieldError } from '../Field/FieldError';
import { FlyoverBuilder } from '../Flyover/FlyoverBuilder';
import { formErrorAttribute } from '../Form';
import { useInputContext } from '../Form/withInputContext';
import { Hint } from '../TextInput/Hint';
import { useThemeColor } from '../Theme';
import { useTranslate } from '../util';
import { StyledSelect, StyledSelectArrow, StyledSelectWrapper } from './Select.styled';
import { SelectMenu } from './SelectMenu';
export function SelectField(props) {
  var id = getId(props);
  var fieldMaxWidth = props.width || defaultFieldMaxWidth;
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    htmlFor: id,
    maxWidth: fieldMaxWidth
  }), /*#__PURE__*/React.createElement(Select, _extends({}, props, {
    id: id,
    width: fieldMaxWidth
  })));
}
export function Select(props) {
  var t = useTranslate();
  var textIconColor = useThemeColor('secondaryText');
  var inputContext = useInputContext({
    forceShowValidation: props.forceShowValidation
  });
  var style = {
    width: props.width
  };
  var label = getLabel(props.options, props.value);
  var requiredError = props.required && !props.value ? t('citrix-ui:validation.enter_required_value') : undefined;
  var isErrored = !props.disabled && (!!props.errorMessage || !!requiredError);
  var showError = inputContext.isDirty && isErrored;
  var showWarning = !props.disabled && inputContext.isDirty && !!props.warningMessage;
  return /*#__PURE__*/React.createElement(StyledSelectWrapper, {
    style: style
  }, /*#__PURE__*/React.createElement(FlyoverBuilder, {
    closeOnFlyoverClick: true,
    toggleOnClick: true,
    sameWidth: true,
    flyover: /*#__PURE__*/React.createElement(SelectMenu, {
      items: getOptions(props.options, props.value, props.onChange),
      width: props.width
    }),
    onToggle: function onToggle(isOpen) {
      if (!isOpen) {
        inputContext.makeDirty();
      }
    }
  }, function (buttonProps) {
    return /*#__PURE__*/React.createElement(Button.Wrapper, _extends({}, buttonProps, {
      disabled: props.disabled,
      style: style
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/React.createElement(StyledSelect, _extends({
      showError: showError,
      showWarning: showWarning,
      id: props.id,
      "aria-label": props['aria-label'],
      "aria-labelledby": props['aria-labelledby']
    }, formErrorAttribute(isErrored)), label || props.value), /*#__PURE__*/React.createElement(StyledSelectArrow, {
      size: 16,
      color: textIconColor
    })));
  }), /*#__PURE__*/React.createElement(FieldError, {
    error: showError ? props.errorMessage || requiredError : undefined,
    warning: showWarning ? props.warningMessage : undefined,
    alertAction: props.alertAction,
    htmlFor: props.id
  }), /*#__PURE__*/React.createElement(Hint, {
    hint: props.hint
  }));
}
function getOptions(options, selectedValue, onChange) {
  return options.filter(function (o) {
    return !!o;
  }).map(function (option) {
    if (option.hasOwnProperty('subOptions')) {
      var _option$children;
      return {
        children: (_option$children = option.children) !== null && _option$children !== void 0 ? _option$children : option.label,
        disabled: true,
        items: option.subOptions.filter(function (s) {
          return !!s;
        }).map(function (subOption) {
          return {
            selected: subOption.value === selectedValue && !option.disabled,
            children: option.children || subOption.label || subOption.value,
            disabled: option.disabled === undefined ? false : option.disabled,
            onClick: function onClick() {
              return onChange(subOption.value);
            }
          };
        })
      };
    }
    return {
      selected: option.value === selectedValue && !option.disabled,
      children: option.children || option.label || option.value,
      disabled: option.disabled === undefined ? false : option.disabled,
      onClick: function onClick() {
        return onChange(option.value);
      }
    };
  });
}
function getLabel(options, selectedValue) {
  var matchedOption = options.filter(function (o) {
    return !!o;
  }).find(function (option) {
    if (option.hasOwnProperty('subOptions')) {
      return option.subOptions.filter(function (s) {
        return !!s;
      }).find(function (subOption) {
        return subOption.value === selectedValue;
      });
    }
    return option.value === selectedValue;
  });
  var label = '';
  if (matchedOption) {
    if (matchedOption.hasOwnProperty('subOptions')) {
      var _matchedOption$subOpt;
      var matchedSubOption = (_matchedOption$subOpt = matchedOption.subOptions) === null || _matchedOption$subOpt === void 0 ? void 0 : _matchedOption$subOpt.find(function (subOption) {
        return subOption.value === selectedValue;
      });
      if (matchedSubOption) {
        label = matchedSubOption.label || '';
      }
    } else {
      label = matchedOption.label || '';
    }
  }
  return label;
}